<template>
  <tr
    :class="onItemClick && !disableClick ? 'cursor-pointer' : 'cursor-default'"
    @click="clickFunction"
  >
    <slot />
  </tr>
</template>

<script>
export default {
  name: 'TrTr',
  props: {
    onItemClick: {
      required: false,
      type: Function
    },
    disableClick: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    clickFunction() {
      if (this.onItemClick && !this.disableClick) {
        return this.onItemClick;
      }
      return () => {}
    }
  }
};
</script>